/**
 * @author Swathi
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Task
 */
import dayjs from 'dayjs';
import moment from 'moment';
import { connect } from 'react-redux';
import { constant } from './constants';
import React, { useEffect, useState } from 'react';
import { encode as base64_encode } from 'base-64';
import { useNavigate } from 'react-router-dom';
import translation from '../../../commons/translation';
import StyledTable from "../../../commons/styles/table";
import {
  Input,
  Popconfirm,
  Tooltip,
  Divider,
  Space,
  Card,
  Pagination,
  Select,
  Empty,
  DatePicker,
  Form,
  Typography
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  PlusOutlined,
  SolutionOutlined
} from '@ant-design/icons';
import { CardTitle, StyledFormType, CardFooterActions, StyledNoBorderSelect } from '../CSS/style';

const ListView = (props) => {
  // const columns = useState(props.columns || []);
  const [listData, setListData] = useState(props.dataSource || []);
  const [config, setConfig] = useState(props.config || {});
  const [viewType, setViewType] = useState(config.defaultViewType || 'card');
  const [searchField, setSearchField] = useState('');
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterKey, setFilterKey] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setListData(props.dataSource);
    setConfig(props.config);
  }, [props.userProfile, props.dataSource, props.translationCache, props.config]);

  const filterByValue = (value) => {
    return (
      props.dataSource &&
      Array.isArray(props.dataSource) &&
      props.dataSource.filter((data) => {
        return (
          data[filterKey] &&
          data[filterKey].toString().toLowerCase().includes(value.toString().toLowerCase())
        );
      })
    );
  };

  const onSearch = (value) => {
    const filteredData = filterByValue(value);
    setListData(filteredData);
  };

  const add3Dots = (text, limit) => {
    const dots = '...';
    if (text && text.length > limit) {
      text = text.substring(0, limit) + dots;
    }
    return text;
  };

  const onPaginationChange = (current, pageSize) => {
    setCurrent(current);
    setPageSize(pageSize);
  };

  const onViewTypeChange = (viewType) => {
    setViewType(viewType);
  };

  const deleteRecord = async (id) => {
    props.delete(id);
  };

  const editRecord = async (id) => {
    navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(id)}` });
  };

  const editRecordDetails = async (id) => {
    props.navigate({ pathname: `${config.edit.redirectDetailsURL}/${base64_encode(id)}` });
  };

  const { title, viewTypes, filterType, attributeList, attributeListTitle, firstTitle, secondTitle, thirdTitle, actions, edit, deletee } = config;

  const IconText = ({ icon, text }) => (
    <Space>
      {React.createElement(icon)}
      {text}
    </Space>
  );

  const LabelValue = ({ labelText, valueText }) => (
    <Space>
      {labelText}
      {valueText}
    </Space>
  );

  return (
    <>
      <StyledFormType>
        <Typography.Title level={5}>{title}</Typography.Title>
      </StyledFormType>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <StyledNoBorderSelect>
          {filterType === 'ByAttributeValue' && viewType === 'card' ? (
            <div>
              <Select
                showSearch
                placeholder={translation(props.translationCache, constant.selectAttribute)}
                allowClear
                value={filterKey}
                style={{
                  background: '#1a3652',
                  borderRight: 'none',
                  borderTop: 'none',
                  borderLeft: 'none',
                  width: '40%'
                }}
                onChange={setFilterKey}>
                {attributeList && Array.isArray(attributeList)
                  ? attributeList.map((attribute, index) => (
                    <Select.Option key={attribute}>
                      {attributeListTitle && attributeListTitle[index]
                        ? attributeListTitle[index]
                        : attribute}
                    </Select.Option>
                  ))
                  : null}
              </Select>
              <Input
                type="text"
                style={{
                  borderRight: 'none',
                  borderTop: 'none',
                  borderLeft: 'none',
                  width: '60%'
                }}
                id="searchText"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onSearch(searchField);
                  }
                }}
                placeholder={translation(props.translationCache, constant.search)}
              />
            </div>
          ) : null}
        </StyledNoBorderSelect>

        <div style={{ marginTop: '9px' }}>
          {viewTypes && viewTypes.includes('add') ? (
            <Tooltip
              placement="top"
              key="Add"
              title={translation(props.translationCache, constant.Add)}>
              <PlusOutlined
                onClick={() => {
                  props.navigate({
                    pathname: `${config.edit.redirectURL}/${base64_encode('new')}`
                  });
                }}
                style={{
                  
                  marginLeft: '10px'
                }}
              />
            </Tooltip>
          ) : null}
          <Divider type="vertical" />
          {viewTypes && viewTypes.includes('card') ? (
            <Tooltip
              placement="top"
              key="GridView"
              title={translation(props.translationCache, constant.GridView)}>
              <AppstoreOutlined
                onClick={() => onViewTypeChange('card')}
                style={{
                  
                  marginLeft: '10px'
                }}
              />
            </Tooltip>
          ) : null}

          {viewTypes && viewTypes.includes('table') ? (
            <Tooltip
              placement="top"
              key="ListView"
              title={translation(props.translationCache, constant.ListView)}>
              <UnorderedListOutlined
                onClick={() => onViewTypeChange('table')}
                style={{
                  
                  marginLeft: '10px'
                }}
              />
            </Tooltip>
          ) : null}
        </div>
      </div>
      {props.selection && props.selection.widget && props.selection.widget === 'date-picker' ? (
        <div style={{ display: 'flex', justifyContent: 'right', margin: '10px 0px' }}>
          <Form>
            <Form.Item label="Select Date">
              <DatePicker
                placeholder="Select Date"
                defaultValue={dayjs()}
                onChange={(e) => props._getDataSource(dayjs(e).format('YYYY-MM-DD'))}
              />
            </Form.Item>
          </Form>
        </div>
      ) : null}

      <div style={{ marginTop: '10px' }}>
        {viewType === 'card' ? (
          <div>
            {listData && Array.isArray(listData) && listData.length !== 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {listData
                  .filter(
                    (e, index) =>
                      index >= pageSize * current - pageSize && index < pageSize * current
                  )
                  .map((list) => (
                    <Card
                      key={list.TaskName}
                      style={{ width: '410px', padding: '5px', margin: '5px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <CardTitle>
                          {add3Dots(list[firstTitle], 35)}
                        </CardTitle>

                        <div style={{ margin: '0px 0px 7px 0px' }}>
                          {config.TitleView === true ? (
                            <LabelValue
                              labelText={
                                config.InspectionView === true
                                  ? 'Description :'
                                  : `${config.secondTitle}:`
                              }
                              valueText={list[secondTitle]}
                              key="list-vertical-star-o"
                            />
                          ) : (
                            <IconText
                              icon={UserOutlined}
                              text={list[secondTitle]}
                              key="list-vertical-star-o"
                            />
                          )}
                        </div>
                        {config && config.thirdTitle ? (
                          config.TitleView === true ? (
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <LabelValue
                                labelText={`${config.thirdTitle}:`}
                                valueText={list[thirdTitle]}
                                key="list-vertical-like-o"
                              />
                            </div>
                          ) : (
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={CalendarOutlined}
                                text={moment(list[thirdTitle])
                                  .utc()
                                  .local()
                                  .format('YYYY-MM-DD HH:mm:ss')}
                                key="list-vertical-like-o"
                              />
                            </div>
                          )
                        ) : null}
                      </div>
                      <Divider
                        style={{
                          borderTop: '1px solid #000',
                          height: '0px',
                          margin: '15px 0px'
                        }}
                      />

                      <CardFooterActions>
                        {actions && actions.includes('edit') ? (
                          <Tooltip
                            placement="top"
                            key="Edit"
                            title={translation(props.translationCache, constant.Edit)}>
                            <EditOutlined
                              style={{
                                marginRight: '8px'
                              }}
                              onClick={() => editRecord(list[edit.byAttribute])}
                            />
                          </Tooltip>
                        ) : config.InspectionView === true ? (
                          <Tooltip
                            placement="right"
                            title={translation(
                              props.translationCache,
                              constant.ViewInspection
                            )}>
                            <EyeOutlined
                              onClick={() => editRecord(list[edit.byAttribute])}
                            />
                          </Tooltip>
                        ) : null}
                        <Divider type="vertical" />
                        {actions && actions.includes('delete') ? (
                          <Popconfirm
                            key="1"
                            title="Are you sure you want to delete the record ?"
                            icon={<QuestionCircleOutlined />}
                            onConfirm={() => deleteRecord(list[deletee.byAttribute])}
                            okText="Yes"
                            cancelText="No">
                            <Tooltip
                              placement="top"
                              key="Delete"
                              title={translation(props.translationCache, constant.Delete)}>
                              <DeleteOutlined
                                style={{
                                  marginRight: '8px'
                                }}
                              />
                            </Tooltip>
                          </Popconfirm>
                        ) : null}
                        <Divider type="vertical" />
                        {actions && actions.includes('details') ? (
                          <Tooltip
                            placement="top"
                            key="Edit"
                            title={translation(props.translationCache, constant.Edit)}>
                            <SolutionOutlined
                              style={{
                                marginRight: '8px'
                              }}
                              onClick={() => editRecordDetails(list[edit.byAttribute])}
                            />
                          </Tooltip>
                        ) : null}
                      </CardFooterActions>
                    </Card>
                  ))}
              </div>
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}

            {listData && Array.isArray(listData) && listData.length !== 0 ? (
              <div style={{ display: 'flex', flexDirection: 'row', margin: '14px' }}>
                <Pagination
                  current={current}
                  onChange={onPaginationChange}
                  total={listData.length}
                  pageSize={10}
                />
              </div>
            ) : null}
          </div>
        ) : (
          <StyledTable size="small"
            dataSource={props.dataSource && Array.isArray(props.dataSource) ? props.dataSource : []}
            columns={props.columns && Array.isArray(props.columns) ? props.columns : []}
            scroll={{ x: 1300 }} />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(ListView);